<template>
    <v-layout>
        <app-sidebar>
            <router-link :to="{ name: ROUTES.HOME }">
                <app-link icon="mdi-arrow-left">Back to your Cases</app-link>
            </router-link>
        </app-sidebar>

        <app-main-view>
            <app-form-title> Admin</app-form-title>
            <app-main-card>
                <h4>Case</h4>
                <label>name: </label>
                <span class="text-caption">{{ store.case?.name }}</span>
                <br />

                <label>description: </label>
                <span class="text-caption">{{ store.case?.description }}</span>
                <br />

                <label>status: </label>
                <code class="text-caption">{{ store.case?.status }}</code>
                <br />
                <br />
            </app-main-card>

            <div v-if="store.case">
                <AdminStudyCard
                    v-for="(study, index) in store.studies"
                    :key="index"
                    :study="study"
                    :project="store.case"
                />
            </div>
        </app-main-view>
    </v-layout>
</template>

<script setup lang="ts">
    import AppSidebar from '@/admin/AppSidebar.vue';
    import AppLink from '@/components/AppLink.vue';
    import AppMainView from '@/components/AppMainView.vue';
    import AppFormTitle from '@/components/forms/AppFormTitle.vue';
    import { ROUTES } from '@/router';
    import { useAdminCaseStore } from '@/admin/store';
    import AdminStudyCard from '@/admin/AdminStudyCard.vue';

    const store = useAdminCaseStore();
    await store.load();
</script>

<style scoped></style>
